import {Alert, useOpenModal} from '@/components/Modal/index.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'
import metaBizNode from '../../../metaBizNode.mjs'

const BDLOGIC_NAME = metaBizNode.BDLOGIC.name

export default props => {
    const openModal = useOpenModal()
    const map = useMapContext()
    const {mapTypeCode} = map.data

    if ('_BD_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = async () => {
        const nodes = [...map.selectedNodes]


        const ns = nodes.filter(node => {
            const {bizNodeType, pkid, prjId} = node.data

            return (
                pkid &&
                prjId === map.data.prjId &&
                /^(BDLOGIC)$/.test(bizNodeType)
            )
        })

        if (0 === ns.length) {
            await openModal(
                <Alert type="error">
                    请先选择{BDLOGIC_NAME}
                </Alert>
            )

            return
        }

        if (ns.length < nodes.length) {
            await openModal(
                <Alert type="warn">
                    选中的节点有些不是{BDLOGIC_NAME}，它们将被忽略
                </Alert>
            )
        }

        const {prjId, sVer} = map.data
        const {pkid: bdId} = map.root.data
        const bdlogicIds = []
        const bdlogicNames = []

        for (const n of ns) {
            const {pkid, ruleTitle} = n.data
            bdlogicIds.push(pkid)
            bdlogicNames.push(ruleTitle)
        }

        openWindow(
            '/Ai',

            {
                bizMap: {bdId, bdlogicIds},
                prjId,
                scene: 'GENERATE_TG',
                sVer,
                title: `${BDLOGIC_NAME}: ${bdlogicNames.join(', ')}`,
            }
        )
    }

    return {
        label: '程序能力设计',
        onClick,
        ...props,
    }
}
